module.exports = __webpack_public_path__ + "static/media/Nexa-Light.1be8e553.otf";